import { RealTimeAPI } from "rocket.chat.realtime.api.rxjs";
const url = `${window._env_.realtimeAPI}`;
let realtimeAPI = new RealTimeAPI(url);
realtimeAPI.connectToServer()

export const connectRealtimeAPI = () => {
    return realtimeAPI
}

export const logInRealtimeAPI = (auth) => {
    realtimeAPI.keepAlive().subscribe(console.log)
    realtimeAPI.loginWithAuthToken(auth).subscribe(
        (authResult) => {
         //   console.log("authResult", authResult);
            if (authResult.msg === "result") {
                if (authResult.error === undefined) {
                                  
                } else {
                    console.log("login fail handle here");
                }
            }
        },
        (error) => {
            console.log("login error (may be network)", error);
        }
    )
}

export const MessageMethod = (msg) => {
    
    realtimeAPI.sendMessage(msg)
}